import { prependRoot } from "../../util/prependRoot.js";
import { getApiRoot } from "../../store/configureStore.js";
import axios from "axios";

const routePrefix = "/shared/global/";

const ReferentieApi = {
	getAll() {
		const serviceUrl = prependRoot(routePrefix + 'getallreferences', getApiRoot());
		return axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
	}
};

export default ReferentieApi;
